import Container from '@material-ui/core/Container'
import React from 'react'
import Navbar from 'components/Navbar'
import Sidebar from 'components/Sidebar'
import { useSelector, useDispatch } from 'react-redux'
import { ReactComponent as MoveRight } from 'static/icons/move-right.svg'
import { setSidebarIsOpen } from 'utils/common/actions'
import useStyles from './styles'


const PrivateRoutePage = (props) => {
  const { children } = props
  const dispatch = useDispatch()
  const isMobile = useSelector(state => state.common.isMobile)
  const isDesktop = useSelector(state => state.common.isDesktop)
  const isOpenSidebar = useSelector(state => state.common.isOpenSidebar)
  const classes = useStyles({isMobile})

  const handleDrawerOpen = () => {
    dispatch(setSidebarIsOpen(true))
  }

  const handleDrawerClose = () => {
    dispatch(setSidebarIsOpen(false))
  }

  return (
    <>
      {
        !isOpenSidebar && isDesktop &&
          <div className={classes.openSidebarBadge} onClick={handleDrawerOpen}>
            <MoveRight className={classes.openSidebarIcon} />
          </div>
      }
      <Sidebar
        classes={{
          ...{drawer: classes.drawer},
          ...{drawerPaper: classes.drawerPaper},
          ...{drawerOpen: classes.drawerOpen},
          ...{drawerClose: classes.drawerClose},
        }}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        open={isOpenSidebar}
        isDesktop={isDesktop}
      />
      <Container className={classes.content} maxWidth='xl' disableGutters>
        <Navbar
          classes={{...{appBar: classes.appBar}}}
          handleDrawerOpen={handleDrawerOpen}
        />
          { children ? children : null}
      </Container>
    </>
  )
}

export default PrivateRoutePage
